"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const EventEmitter = require("wolfy87-eventemitter");
class NullEventHub {
    constructor() {
        this.errorOccurred = new EventEmitter();
    }
    async publishAsync(e, receivers) { }
    registerEventHandler(category, handler) { }
    unRegisterEventHandler(category) { }
    subscribeEventHandler(category, eventName, evtHandler, onError) { return rxjs_1.Subscription.EMPTY; }
    subscribeEventAsyncHandler(category, eventName, evtHandler, onError) { return rxjs_1.Subscription.EMPTY; }
    receiveEvent(evt) { }
    async receiveEventAsync(evt) { }
}
exports.NullEventHub = NullEventHub;
exports.NullEventHubSingleton = new NullEventHub();
//# sourceMappingURL=NullEventHub.js.map